import SystemHelper from 'features/System/systemHelper';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useState } from 'react';

DialogSendFeedbackView.propTypes = {
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogSendFeedbackView({ item, onCancel, onDone }) {
  // MARK: ---- PROPERTIES ----
  const [loading, setLoading] = useState(false);
  const [readyToValidate, setReadyToValidate] = useState(false);
  const [feedback, setFeedback] = useState('');

  // MARK: ---- METHODS ----
  const handleSubmit = async () => {
    setReadyToValidate(true);
    if (!Utils.isValid(feedback)) {
      ToastHelper.showError('Vui lòng nhập phản hồi');
      return;
    }
    const params = {
      feedback: feedback,
    };
    setLoading(true);
    const res = await SystemHelper.API.EnergyBill.requestUpdateEnergyBill(item?.billId, params);
    setLoading(false);
    if (_.isBoolean(res) && res) {
      ToastHelper.showSuccess('Gửi phản hồi thành công');
      onDone();
    } else if (_.isString(res)) {
      ToastHelper.showError(res);
    }
  };

  return (
    <div>
      <div className="row m-0 p-0 px-2">
        <div className="col-12 mb-4 px-2">
          <div>
            {UIHelper.buildFormLabel('Nội dung', true)}
            <KTFormTextArea
              placeholder="Nhập nội dung phản hồi"
              name="feedback"
              value={feedback}
              onChange={(value) => {
                setFeedback(value);
              }}
              enableCheckValid={readyToValidate}
              isValid={Utils.isValid(feedback)}
              isTouched={readyToValidate}
              feedbackText={!Utils.isValid(feedback) ? 'Vui lòng nhập phản hồi' : ''}
            />
          </div>
        </div>
      </div>
      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Gửi phản hồi', handleSubmit, null, true, loading)}
      </div>
    </div>
  );
}

export default DialogSendFeedbackView;
